"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButticonBase = exports.Butticon = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var signal_1 = require("./styled/signal");

var Butticon = (0, react_1.forwardRef)(function (_a, ref) {
  var __UIScope = _a.__UIScope,
      className = _a.className,
      title = _a.title,
      icon = _a.icon,
      _b = _a.size,
      size = _b === void 0 ? 'tiny' : _b,
      _c = _a.pattern,
      pattern = _c === void 0 ? 'secondary' : _c,
      isOutlined = _a.isOutlined,
      _d = _a.isGhost,
      isGhost = _d === void 0 ? !isOutlined : _d,
      id = _a.id,
      label = _a.label,
      withSignal = _a.withSignal,
      rest = tslib_1.__rest(_a, ["__UIScope", "className", "title", "icon", "size", "pattern", "isOutlined", "isGhost", "id", "label", "withSignal"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Butticon',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var asGhostButton = isGhost && pattern !== 'secondary';

  if ('href' in rest) {
    var disabled = rest.disabled,
        href = rest.href,
        onClick = rest.onClick,
        restOfATagProps = tslib_1.__rest(rest, ["disabled", "href", "onClick"]);

    var propsDependentOnDisabled = disabled ? {
      'aria-disabled': true,
      role: 'link'
    } : {
      href: href,
      onClick: onClick
    };
    return react_1.default.createElement(root_1.Root, tslib_1.__assign({
      className: rootClasses,
      as: "a",
      "aria-label": title,
      title: title,
      size: size,
      pattern: pattern,
      isGhost: isGhost,
      isOutlined: asGhostButton || isOutlined,
      ref: ref
    }, propsDependentOnDisabled, restOfATagProps), react_1.default.createElement(ui_icon_1.Icon, {
      name: icon,
      focusable: "false",
      "aria-hidden": "true",
      isFlexible: true,
      isParentColor: true,
      id: id
    }), withSignal && react_1.default.createElement(signal_1.Signal, {
      label: label,
      type: "notification",
      pattern: "danger",
      sizeOption: size,
      withLabel: Boolean(label)
    }));
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses,
    "aria-label": title,
    title: title,
    size: size,
    pattern: pattern,
    isGhost: isGhost,
    isOutlined: asGhostButton || isOutlined,
    ref: ref
  }, rest), react_1.default.createElement(ui_icon_1.Icon, {
    name: icon,
    focusable: "false",
    "aria-hidden": "true",
    isFlexible: true,
    isParentColor: true,
    id: id
  }), withSignal && react_1.default.createElement(signal_1.Signal, {
    label: label,
    type: "notification",
    pattern: "danger",
    sizeOption: size,
    withLabel: Boolean(label)
  }));
});
exports.ButticonBase = Butticon;
Butticon.displayName = 'Butticon';
var ButticonWithSpace = (0, ui_helper_with_space_1.withSpace)(Butticon);
exports.Butticon = ButticonWithSpace;